<style scoped>
	.c-panel{margin: 0px; padding: 0px 20px;}
</style>

<template>
	<el-dialog
		v-if="m"
		:title="m.id == 0 ? '数据增加' : '数据修改'"
		:visible.sync="isShow"
		width="400px"
		top="25vh"
		:append-to-body="true"
		:destroy-on-close="true"
		:close-on-click-modal="false"
		custom-class="full-dialog"
		>
		<div class="vue-box">
			<div class="c-panel">
				<!-- 参数栏 -->
				<br>
				<el-form size="mini">
					<el-form-item label="编号：" v-show="m.id!=0">
						<el-input v-model="m.id" disabled></el-input>
					</el-form-item>
					<el-form-item label="名称：">
						<el-input v-model="m.name"></el-input>
					</el-form-item>
					<el-form-item label="适合年龄：">
            <el-input v-model="m.ageS" size="mini" style="width: 50px"></el-input>-
            <el-input v-model="m.ageE" size="mini" style="width: 50px"></el-input>
					</el-form-item>
					<el-form-item label="描述：">
            <el-input v-model="m.des"></el-input>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="isShow = false">取 消</el-button>
			<el-button size="small" type="primary" @click="ok()">确 定</el-button>
		</span>
	</el-dialog>
</template>

<script>
	export default {
		data() {
			return {
				isShow: false,
				id: 0,
				m: null,

			}
		},
		methods: {
			// 打开 
			open: function(id) {

				// this.id = id;
				this.isShow = true;
				if(id == 0){	// 如果是添加
					this.m = this.create_m();
				} else {
					//id 非 0 代表 是要修改 先查询一下，把旧值显示在input中
					this.sa.ajax('api/psdAdmin/subject/getSubjectInfoById', {id: id}, function(res) {
						this.m = res.data;
					}.bind(this), /*{res: this.getMockData(id)}*/);
				}
			},
			// 表单验证  
			submit_check: function() {
				var m = this.m;
				var sa = this.sa;
				if(sa.isNull(m.name)) {
					return sa.error('请输入科目名称');
				}
				if(sa.isNull(m.ageS) || sa.isNull(m.ageE) ) {
					return sa.error('请输入年龄段');
				}
        if(sa.isNull(m.des)) {
          return sa.error('请输入科目描述');
        }
				return 'ok';
			},
			// 提交 
			ok: function() {
				// 表单验证 
				if(this.submit_check() != 'ok') {
					return;
				}
				// 开始增加或修改
				let self = this;
				if(this.m.id == 0) {
					// id == 0 为增加
          console.log(this.m);
					this.sa.ajax('api/psdAdmin/subject/addSubjectInfo', JSON.stringify(this.m), function(res) {
					  if(res.code == '0'){
              self.sa.alert('增加成功', function() {
                self.$parent.f5();	// 父视图刷新
                self.isShow = false;
              });
            }else{
              this.sa.error(res.msg || '新增失败');
            }

					},{ contentType:"application/json;charset=UTF-8"});
				} else {
					// id != 0 为修改  
					this.sa.ajax('api/psdAdmin/subject/updateSubjectInfo', JSON.stringify(this.m), function(res){
            if(res.code == '0') {
              self.sa.alert('修改成功', function () {
                self.$parent.f5();	// 父视图刷新
                self.isShow = false;
              });
            }else{
              this.sa.error(res.msg || '修改失败');
            }
					},{ contentType:"application/json;charset=UTF-8"});
				}
			},
			// 创建一个空的model 
			create_m: function() {
				return {
					id: 0, 
					name: '',
          ageS:'',
          ageE:'',
          des:''
				}
			},
		},
		created: function(){
		}
	}
</script>
